<template>
  <div>
   
    <el-container style="min-height: 600px">


      <div class="main-container" v-loading="loading">
        <!-- <div style="width:100%; display: block;">
          <h2 v-show="!isAppFlag" style="text-align: center;"> {{ $t('app_title') }}</h2>
        </div> -->
        <div class="card-container">

          <br />
          <router-view></router-view>
          <div class="footer">
            <br />

            <pre> {{ versionText }} </pre>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import { changeLang } from "@/i18n.js";
import { version } from "./config.js";
import { setTitle } from "./i18n.js";
import { startIntegration } from "./govmo_integration";

export default {
  data() {
    return {
      loading: true,
      versionText: "",
      isAppFlag: true,
    };
  },
  mounted() {
    setTitle();
  },
  created() {
    this.isAppFlag = this.isApp();
    this.versionText = version;
    console.log("version:", version);

    const currentLocation = window.location;
    const urlSearchParams = new URLSearchParams(currentLocation.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    console.log("currentLocation:", currentLocation);
    const seq = params["seq"];
    if (!seq) {
      const newLocation = `${currentLocation}`.replace(
        "app/#",
        `app/?seq=${new Date().valueOf()}/#`
      );
      console.log("redirect to", newLocation);
      window.location = newLocation;
    } else {
      this.loading = false;

      startIntegration(window);
    }
  },
  methods: {
    isApp() {
      return window.GovAppBridge || window.webkit;
    },
    changelocale(locale) {
      changeLang(locale);
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "MING-MSCS-DSI";
  src: url("../public/dsifonts/MING-MSCS-DSI.TTF");
}


.banner-text {
  color: #015845;
  background-color: white;
  line-height: 22px;
  padding: 10px 20px;
  font-size: 18px;
  margin-left: 50px;
  font-weight: bold;
}

@media screen and (max-width: 700px) {
  .banner-icon {
    display: none;
  }

  .banner-text {
    margin-left: 0px;
  }
}

.lang {
  margin-left: 5px;
  margin-right: 5px;
}

.main-container {
  flex: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;

}

.card-container {
  width: 90%;
  max-width: 700px;
}

.footer {
  text-align: center;
}

.footer p {
  font-size: 12px;
}

.description {
  width: 95%;
  max-width: 580px;
}

.description p {
  font-size: 14px;
}
</style>

<style lang="scss">
//$teal: rgb(0, 124, 137);
$teal: #13a07b;

.round-dialog {
  border-radius: 20px;
  margin-top: 50px !important;
  margin-top: calc(50px + constant(safe-area-inset-top)) !important;
  margin-top: calc(50px + env(safe-area-inset-top)) !important;
}



.el-message.el-message--success {
  top: 30% !important;
}

.el-message.el-message--error {
  top: 30% !important;
}

.el-message.el-message--warning {
  top: 30% !important;
}

.vs__selected {
  background-color: red;
}

.el-button.gradient-button1 {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  background-image: linear-gradient(52deg, $teal 0%, $teal 48%, $teal 100%);
  border-radius: 25px;
  border: none;
  color: rgb(255, 255, 255)
}

.el-radio__input.is-checked {
  color: $teal;
}

.el-radio__input.is-checked+.el-radio__label {
  color: $teal;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: $teal;
  background: $teal;
}

.el-button.gradient-button1.is-disabled {
  background-image: none;
  background: #e5e5e5 !important;
  color: #acacac !important;

  :hover {
    background: #e5e5e5 !important;
    color: #acacac !important;
  }
}


.el-button.gradient-button2 {
  width: 100%;
  background: #ffffff;
  color: $teal;
  border-radius: 25px;

  border-color: $teal;

}

.el-button.gradient-button3 {
  width: 100%;
  background: rgba(232, 242, 242, 0.8);
  color: rgba(19, 160, 123, 1);
  border-color: rgba(19, 160, 123, 1) !important;
  border-radius: 25px;

  border-color: $teal;

}

.el-button.normal-button {
  width: 100%;
  border-radius: 25px;
}

.el-button.normal-button.is-disabled {
  background-image: none;
  background: #e5e5e5 !important;
  color: #acacac !important;
  border: none;

  :hover {
    background: #e5e5e5 !important;
    color: #acacac !important;
  }
}

.el-tabs__item.is-active {
  color: $teal;
}

.el-tabs__active-bar {
  background-color: $teal;
}

.el-switch__label.is-active {
  color: $teal;
}

.el-form-item {
  margin-bottom: 5px;
}

.el-button--primary {
  background: $teal;
  border-color: $teal;

  &:hover,
  &.active,
  &:focus {
    background: lighten($teal, 7);
    border-color: lighten($teal, 7);
  }
}

.el-input__inner:hover {
  border-color: $teal;
}

.el-input__prefix {
  background: rgb(238, 237, 234);
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;

  .el-input__icon {
    width: 30px;
  }
}

.el-input input {
  padding-left: 10px;
}

a {
  color: $teal;
  text-decoration: none;

  &:hover,
  &:active,
  &:focus {
    color: lighten($teal, 7);
  }
}

.action-button {
  width: 100%;
  margin-top: 20px;
}

.dsi-font {
  font-family: "MING-MSCS-DSI", serif;
}

.footer pre {
  font-size: 14px;
}

h1 {
  font-size: 1.8em;
}

p,
li {
  font-size: 1.1em;
}

.el-radio__label {
  font-size: 16px;
  display: inline-block;
  white-space: normal;

}

.el-input,

.el-table,
.langtab .el-link,
button span {
  font-size: 16px;
}

.child-select {
  width: 100%;

  .el-input {
    font-size: 20px;

    .el-input__inner {
      border-radius: 18px;
    }
  }
}

.child-dropdown {
  display: none;
}

body {
  background-color: #dbf0ee;
  word-wrap: break-word;
  word-break: break-word !important;


  font-family: "PingFang SC";
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
}

.el-card {
  border-radius: 20px;
}

.name-btn {
  border-radius: 20px;
  width: 100%;
  font-size: 12px;

  span {
    font-size: 18px;
  }
}


.name-card {
  margin: 10px;
  font-family: "MING-MSCS-DSI", serif;
  width: 100%;
}

.main-button {
  width: 100%;
}

.app-title {
  width: 100%;
  height: 35px;
  text-align: center;
  font-size: 23px;
  background-color: rgb(255, 255, 255);
  padding-top: 10px;
  padding-bottom: 10px;

  top: 0px !important;
  top: constant(safe-area-inset-top) !important;
  top: env(safe-area-inset-top) !important;
  left: 0;


}
</style>
